/**
 * US states + DC for dropdowns. Sourced from typed-usa-states.
 * value = two-letter abbreviation, label = full name.
 * Default selection is empty (no value).
 */
import { usaStates } from "typed-usa-states";

export const US_STATES = usaStates
  .filter((s) => !s.territory || s.abbreviation === "DC")
  .map((s) => ({
    value: s.abbreviation,
    label: s.name,
  }))
  .sort((a, b) => a.label.localeCompare(b.label));

export default US_STATES;
